import React, { forwardRef } from 'react';
import SimpleDayPicker from '../dayDatePickerWrapper/DayDatePickerWrapper';
import DatePickerWrapper from '../DatePickerWrapper';
import DatePickerManager from '../utils/DatePickerManager';
import WeekDays from '../weekDays/WeekDays';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './ScrollDatepicker.module.scss';
const DatePicker: React.FC<any> = forwardRef(({
  checkInDate,
  checkOutDate,
  months,
  hoveredDate,
  onDayClick,
  onDayHover,
  todayDate,
  dateType = 'JALALI',
  nextRangeDays,
  isFull = false,
  headerChildren,
  footerChildren,
  withTooltip
}, ref) => {
  return <Box className={styles['scroll-datepicker']}>
        <Box className={styles['calendar-scroll-wrapper']}>
          {headerChildren && <>{headerChildren}</>}
          {months.map((item, index) => <Box className={styles['date-picker-header']} key={index}>
              <Typography component="p" variant="bodyL_Bold" className={styles['months-wrapper']}>
                {DatePickerManager.monthNameConvertor(item, dateType)}{' '}
              </Typography>
              <WeekDays fullWidth />
              <Box className={styles['days-wrapper']}>
                <SimpleDayPicker pickerDate={item} hoveredDate={hoveredDate} checkInDate={checkInDate} checkOutDate={checkOutDate} onDayClick={onDayClick} onDayHover={onDayHover} todayDate={todayDate} nextRangeDays={nextRangeDays} isFull={isFull} withTooltip={withTooltip} />
              </Box>
            </Box>)}
          {footerChildren && <>{footerChildren}</>}
        </Box>
      </Box>;
});
DatePicker.displayName = 'DatePicker';

// eslint-disable-next-line new-cap
const DatePickerScroll = props => {
  return <>
      <DatePickerWrapper WrappedDatePicker={DatePicker} datePickerType="MULTI_COLUMN_RANGE_Scroll" ref={props.dateRef} key={'MULTI_COLUMN_RANGE_Scroll'} {...props} data-sentry-element="DatePickerWrapper" data-sentry-source-file="ScrollDatepicker.tsx" />
    </>;
};
export default DatePickerScroll;